// This file was automatically generated from appchart.dialog.implantableDeviceList.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.implantableDeviceList');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.implantableDeviceList.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer"><div id="view-implantable-device-list"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.implantableDeviceList.list = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.implantableDevices.length) {
    output.append('<ul class="mv5">');
    var implantableDeviceList1595 = opt_data.implantableDevices;
    var implantableDeviceListLen1595 = implantableDeviceList1595.length;
    for (var implantableDeviceIndex1595 = 0; implantableDeviceIndex1595 < implantableDeviceListLen1595; implantableDeviceIndex1595++) {
      var implantableDeviceData1595 = implantableDeviceList1595[implantableDeviceIndex1595];
      output.append('<li class="implantable-device-item" data-id="', soy.$$escapeHtml(implantableDeviceData1595.id), '"><p><a class="implantable-device-show-trigger">', soy.$$escapeHtml(implantableDeviceData1595.deviceDescription), ', ', soy.$$escapeHtml(implantableDeviceData1595.location), '</a></p><div class="implantable-device-remove-trigger el8ItemButtonWrapRight mv5"><button type="button" class="el8button el8ItemButton remove-implantable-device-trigger">Remove</button></div></li>');
    }
    output.append('</ul>');
  } else {
    output.append('<p class="el8FeedEmpty">No implantable devices</p>');
  }
  output.append('<p><a class="implantable-device-add-trigger">+ Add implantable device</a></p>');
  if (!opt_sb) return output.toString();
};
